var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDeliveryTimeClock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C363F",
    d: "M16.5 10a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0M2 10a8.0001 8.0001 0 0 0 13.6569 5.6569 8.0005 8.0005 0 0 0 0-11.3137A8.0001 8.0001 0 0 0 2 10m7.25-4.25V10c0 .25.125.4844.3344.625l3 2c.3437.2313.8093.1375 1.0406-.2094a.7475.7475 0 0 0-.2094-1.0406L10.75 9.6V5.75A.748.748 0 0 0 10 5a.748.748 0 0 0-.75.75"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDeliveryTimeClock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/delivery-time-clock.b844409486764ac4b79428f5fcca1113.svg";